import React from "react";

const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.sportyfo.app";

const PlayBadge = () => (
  <a
    className="download-btn play"
    href={GOOGLE_PLAY_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className="icon">▶</span>
    <span>
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>
);

const AppStoreBadge = () => (
  <button className="download-btn appstore" disabled>
    <span className="icon"></span>
    <span>
      <small>Coming soon</small>
      <strong>App Store</strong>
    </span>
  </button>
);

export default function Home() {
  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }

        body {
          margin: 0;
          overflow-x: hidden;
          background: linear-gradient(180deg, #f8fafc, #eef2f7);
          color: #0f172a;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        .hero {
          min-height: calc(100vh - 80px);
          display: grid;
          grid-template-columns: 1.1fr 1fr;
          gap: 80px;
          align-items: center;
          padding: 100px 0;
        }

        .logo-large {
          font-size: 72px;
          margin-bottom: 12px;
        }

        h2 {
          font-size: 44px;
          line-height: 1.2;
          margin-bottom: 18px;
          font-weight: 700;
        }

        p {
          font-size: 18px;
          line-height: 1.6;
          color: #475569;
          max-width: 520px;
        }

        .download-row {
          display: flex;
          gap: 18px;
          margin-top: 34px;
        }

        .download-btn {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 26px;
          border-radius: 18px;
          text-decoration: none;
          color: white;
          border: none;
          font-size: 14px;
          cursor: pointer;
          box-shadow: 0 12px 30px rgba(0,0,0,0.15);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .download-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 18px 40px rgba(0,0,0,0.2);
        }

        .download-btn small {
          display: block;
          opacity: 0.85;
          font-size: 11px;
          letter-spacing: 0.04em;
        }

        .download-btn strong {
          font-size: 16px;
          font-weight: 600;
        }

        .play {
          background: linear-gradient(135deg, #22c55e, #16a34a);
        }

        .appstore {
          background: #64748b;
          opacity: 0.6;
          cursor: not-allowed;
        }

        .hero-right {
          display: flex;
          justify-content: center;
        }

        .screenshots {
          display: flex;
          gap: 28px;
          align-items: center;
        }

        .screenshot {
          width: 180px;
          border-radius: 28px;
          box-shadow: 0 25px 60px rgba(0,0,0,0.35);
          background: #fff;
        }

        .screenshots img:nth-child(1) {
          transform: translateY(20px) scale(0.95);
          opacity: 0.85;
        }

        .screenshots img:nth-child(2) {
          transform: translateY(-20px) scale(1.05);
          z-index: 2;
        }

        .screenshots img:nth-child(3) {
          transform: translateY(20px) scale(0.95);
          opacity: 0.85;
        }

        @media (max-width: 900px) {
          .hero {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 60px;
          }

          p {
            margin: 0 auto;
          }

          .download-row {
            justify-content: center;
            flex-wrap: wrap;
          }

          .screenshots {
            justify-content: center;
          }
        }
      `}</style>

      <section className="hero container">
        <div>
          <div className="logo-large">🏸</div>
          <h2>Sportyfo – Your ultimate badminton companion</h2>
          <p>
            Track matches, analyze performance, find local partners, and improve
            your game with a clean, powerful app designed for badminton players.
          </p>

          <div className="download-row">
            <PlayBadge />
            <AppStoreBadge />
          </div>
        </div>

        <aside className="hero-right">
          <div className="screenshots">
            <img
              src="/screenshots/screenshot1.jpeg"
              alt="Sportyfo home screen"
              className="screenshot"
            />
            <img
              src="/screenshots/screenshot2.jpeg"
              alt="Match tracking"
              className="screenshot"
            />
            <img
              src="/screenshots/screenshot3.jpeg"
              alt="Player profile"
              className="screenshot"
            />
          </div>
        </aside>
      </section>
    </>
  );
}
